// @flow
import type { User } from 'types'
import { identify } from './identify'
import reset from './reset'
import waitForAnalytics from './wait'

export function identifyOrReset(user: User | null) {
  waitForAnalytics(() => {
    if (user) {
      identify(user)
      // no user is logged in, but segment thinks there is one logged in, so reset
    } else if (window.analytics.user().id()) {
      reset()
    }
  })
}
